import { useCallback, useContext, useRef, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";
import axios from "axios";

const useBanner = () => {
  const { api,api3, userID, latitude, longitude, adminId } =
    useContext(GlobalContext);

  const [status, setStatus] = useState(null);

  const fetchLockRef = useRef(new Set());
  const createLockRef = useRef(false);
  const deleteLockRef = useRef(new Set());
  const updateLockRef = useRef(new Set());
  const appBannerCreateLockRef = useRef(false);
const appBannerFetchLockRef = useRef(false);

  const postRequest = async (endpoint, payload = {}) => {
    const response = await api.post(endpoint, payload);

    return response?.data;
  };

  const fetchStatus = async () => {
    try {
      const data = await postRequest("/Inventory/v2.0/getBannerStatus", {});

      if (data?.responseCode === "00") {
        setStatus(data?.response);

        return true;
      }

      toast.error(data?.responseMessage || "Failed to fetch status");

      return false;
    } catch (err) {
      console.log("Status API error:", err);

      toast.error("Status API error");

      return false;
    }
  };

  const fetchBanner = async (setFetchedBanner, selectedUserId) => {
    const finalUserId = String(selectedUserId || userID || "").trim();

    if (!finalUserId) {
      setFetchedBanner?.([]);
      return false;
    }

    // Fast Refresh safety
    if (!(fetchLockRef.current instanceof Set)) {
      fetchLockRef.current = new Set();
    }

    if (fetchLockRef.current.has(finalUserId)) {
      return false;
    }

    fetchLockRef.current.add(finalUserId);

    try {
      const res = await api.post("/Inventory/v2.0/getCardLayoutGrocery", {
        userid: finalUserId,
        status: "A",
      });

      if (res?.data?.responseCode === "00") {
        const list = Array.isArray(res?.data?.response)
          ? res.data.response
          : [];

        setFetchedBanner?.(list);

        return true;
      }

      setFetchedBanner?.([]);

      return false;
    } catch (error) {
      console.error("fetchBanner error:", error);

      setFetchedBanner?.([]);

      return false;
    } finally {
      fetchLockRef.current.delete(finalUserId);
    }
  };

  const updateBannerStatus = async (item, status) => {
    const cardId = item?.id;

    /*
    GET API se jo fk_userid aa raha hai
    wahi UPDATE API me userid jayega.
  */
    const fkUserId = item?.fk_userid;

    if (!cardId) {
      toast.error("Banner ID not found");
      return false;
    }

    if (!fkUserId) {
      toast.error("Banner user ID not found");
      return false;
    }

    /* =========================================================
     FAST REFRESH SAFETY
  ========================================================= */

    if (!(updateLockRef.current instanceof Set)) {
      updateLockRef.current = new Set();
    }

    /*
    Same banner ka update already running hai
    to duplicate API call block.
  */

    if (updateLockRef.current.has(cardId)) {
      return false;
    }

    updateLockRef.current.add(cardId);

    try {
      const payload = {
        /*
        IMPORTANT:

        GET response:
        fk_userid: "1189"

        UPDATE payload:
        userid: 1189
      */
        userid: Number(fkUserId),

        cardid: Number(cardId),

        status,
      };

      console.log("Update Banner Status Payload:", payload);

      const res = await api.post(
        "/Inventory/v2.0/updateCardLayoutGroceryStatus",
        payload,
      );

      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Banner status updated");

        return true;
      }

      toast.error(res?.data?.responseMessage || "Failed to update banner");

      return false;
    } catch (error) {
      console.error("updateBannerStatus error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Failed to update banner",
      );

      return false;
    } finally {
      updateLockRef.current.delete(cardId);
    }
  };

  const createBanner = async (formData, selectedUserId) => {
    const finalUserId = String(selectedUserId || userID || "").trim();

    if (!finalUserId) {
      toast.error("Please select a client");

      return false;
    }

    if (createLockRef.current) {
      return false;
    }

    createLockRef.current = true;

    try {
      const res = await api.post("/Inventory/v2.0/insertCardLayoutGrocery", {
        userid: finalUserId,

        cardCount: formData.cardCount,

        html: formData.html,

        title: formData.title,

        status: formData.status,
      });

      if (res?.data?.responseCode === "00") {
        toast.success(
          res?.data?.responseMessage || "Banner created successfully",
        );

        return true;
      }

      toast.error(res?.data?.responseMessage || "Failed to create banner");

      return false;
    } catch (error) {
      console.error("createBanner error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Failed to create banner",
      );

      return false;
    } finally {
      createLockRef.current = false;
    }
  };

  const deleteBanner = async (id) => {
    if (!id) {
      toast.error("Banner ID missing");

      return false;
    }

    if (!(deleteLockRef.current instanceof Set)) {
      deleteLockRef.current = new Set();
    }

    if (deleteLockRef.current.has(id)) {
      console.log("Duplicate delete blocked:", id);

      return false;
    }

    deleteLockRef.current.add(id);

    try {
      const payload = {
        id: String(id),
      };

      const res = await api.post("/Inventory/deleteGroceryLayoutV2", payload);

      if (res.data?.responseCode === "00") {
        toast.success(res.data?.responseMessage || "Banner deleted");

        return true;
      }

      toast.error(res.data?.responseMessage || "Delete failed");

      return false;
    } catch (err) {
      console.log("Delete banner error:", err);
      toast.error("Server error");

      return false;
    } finally {
      deleteLockRef.current.delete(id);
    }
  };
  const deleteAppBanner = async (id) => {
    if (!id) {
      toast.error("Banner ID missing");

      return false;
    }

    if (!(deleteLockRef.current instanceof Set)) {
      deleteLockRef.current = new Set();
    }

    if (deleteLockRef.current.has(id)) {
      console.log("Duplicate delete blocked:", id);

      return false;
    }

    deleteLockRef.current.add(id);

    try {
      const payload = {
        banner_id: String(id),
      };

      const res = await api.post("/Chaafo/deleteAppBanner", payload);

      if (res.data?.responseCode === "00") {
        toast.success(res.data?.responseMessage || "Banner deleted");

        return true;
      }

      toast.error(res.data?.responseMessage || "Delete failed");

      return false;
    } catch (err) {
      console.log("Delete banner error:", err);
      toast.error("Server error");

      return false;
    } finally {
      deleteLockRef.current.delete(id);
    }
  };

  const formatAppBannerDateTime = (value = "") => {
    const cleanValue = String(value || "").trim();

    if (!cleanValue) return "";

    const formatted = cleanValue.replace("T", " ");

    return formatted.length === 16 ? `${formatted}:00` : formatted;
  };

  const createAppBanner = async (formData = {}) => {
    if (appBannerCreateLockRef.current) {
      return false;
    }

const bannerName = String(formData.banner_name || "").trim();
const mediaUrl = String(formData.media_url || "").trim();
const restaurantId = String(formData.restaurant_id || "").trim();
const startDate = String(formData.startDate || "").trim();
const endDate = String(formData.endDate || "").trim();



if (!bannerName) {
  toast.error("Banner name is required");
  return false;
}

if (!mediaUrl) {
  toast.error("Media URL is required");
  return false;
}




    const ctaType = String(formData.cta_type || "NONE")
      .trim()
      .toUpperCase();

    const targetType = String(formData.target_type || "GLOBAL")
      .trim()
      .toUpperCase();

    if (ctaType !== "NONE" && !String(formData.cta_value || "").trim()) {
      toast.error("CTA value is required");
      return false;
    }

    if (
      targetType === "CITY" &&
      !String(formData.city_id || "").trim() &&
      !String(formData.city_code || "").trim()
    ) {
      toast.error("City ID or City Code is required");
      return false;
    }

    if (targetType === "RADIUS") {
      if (
        !String(formData.latitude || "").trim() ||
        !String(formData.longitude || "").trim() ||
        !String(formData.radius_km || "").trim()
      ) {
        toast.error(
          "Latitude, longitude and radius are required for radius targeting",
        );
        return false;
      }
    }

    if (formData.start_date && formData.end_date) {
      const startDate = new Date(formData.start_date);
      const endDate = new Date(formData.end_date);

      if (endDate <= startDate) {
        toast.error("End date must be after start date");
        return false;
      }
    }

    appBannerCreateLockRef.current = true;

    try {
 const payload = {
  // varchar(150)
  banner_name: bannerName,

  // varchar(200), Nullable
  banner_title: String(formData.banner_title || "").trim() || null,

  // varchar(300), Nullable
  banner_subtitle: String(formData.banner_subtitle || "").trim() || null,

  // enum
  media_type: String(formData.media_type || "IMAGE")
    .trim()
    .toUpperCase(),

  // varchar(1000)
  media_url: mediaUrl,

  // varchar(1000), Nullable
  thumbnail_url:
    String(formData.thumbnail_url || "").trim() || null,

  // varchar(20), Nullable
  background_color:
    String(formData.background_color || "").trim() || null,

  // varchar(50), Nullable
  cta_text:
    String(formData.cta_text || "").trim() || null,

  // enum
  cta_type: ctaType,

  // varchar(1000), Nullable
  cta_value:
    ctaType === "NONE"
      ? null
      : String(formData.cta_value || "").trim() || null,

  // enum
  target_type: targetType,

  // bigint(20), Nullable
  city_id:
    targetType === "CITY" && formData.city_id !== ""
      ? Number(formData.city_id)
      : null,

  // varchar(50), Nullable
  city_code:
    targetType === "CITY"
      ? String(formData.city_code || "").trim() || null
      : null,

  // decimal(10,8), Nullable
  latitude:
    targetType === "RADIUS" &&
    formData.latitude !== "" &&
    formData.latitude !== null
      ? parseFloat(formData.latitude)
      : null,

  // decimal(11,8), Nullable
  longitude:
    targetType === "RADIUS" &&
    formData.longitude !== "" &&
    formData.longitude !== null
      ? parseFloat(formData.longitude)
      : null,

  // decimal(8,2), Nullable
  radius_km:
    targetType === "RADIUS" &&
    formData.radius_km !== "" &&
    formData.radius_km !== null
      ? parseFloat(formData.radius_km)
      : null,

  // varchar(200), Nullable
  restaurant_id:
    String(formData.restaurant_id || "").trim() || null,

  // bigint(20), Nullable
  category_id:
    formData.category_id !== "" &&
    formData.category_id !== null &&
    formData.category_id !== undefined
      ? Number(formData.category_id)
      : null,

  // enum
  order_type: String(formData.order_type || "ALL")
    .trim()
    .toUpperCase(),

  // enum
  platform: String(formData.platform || "ALL")
    .trim()
    .toUpperCase(),

  // enum
  customer_type: String(formData.customer_type || "ALL")
    .trim()
    .toUpperCase(),

  // varchar(30), Nullable
  minimum_app_version:
    String(formData.minimum_app_version || "").trim() || null,

  // varchar(30), Nullable
  maximum_app_version:
    String(formData.maximum_app_version || "").trim() || null,

  // varchar(100), Nullable
  screen_name:
    String(formData.screen_name || "HOME").trim() || null,

  // varchar(100), Nullable
  banner_position:
    String(formData.banner_position || "").trim() || null,

  // int(11)
  display_order: parseInt(formData.display_order ?? 0, 10),

  // int(11)
  priority: parseInt(formData.priority ?? 0, 10),

  // datetime, Nullable
  start_date:
    formData.start_date
      ? formatAppBannerDateTime(formData.start_date)
      : null,

  // datetime, Nullable
  end_date:
    formData.end_date
      ? formatAppBannerDateTime(formData.end_date)
      : null,

  // bigint(20), Nullable
  created_by:
    formData.created_by || adminId || userID
      ? Number(formData.created_by || adminId || userID)
      : null,
};

      console.log("INSERT APP BANNER PAYLOAD:", payload);

      const res = await api.post("/Chaafo/insertAppBanner", payload, {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      });

      const data = res?.data;

      const success =
        data?.responseCode === "00" ||
        data?.status === "0" ||
        data?.success === true;

      if (success) {
        toast.success(
          data?.responseMessage || "App banner created successfully",
        );

        return true;
      }

      toast.error(
        data?.responseMessage || data?.message || "Failed to create app banner",
      );

      return false;
    } catch (error) {
      console.error("insertAppBanner error:", error?.response || error);

      toast.error(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Failed to create app banner",
      );

      return false;
    } finally {
      appBannerCreateLockRef.current = false;
    }
  };

  const fetchAppBanner = useCallback(
    async ({ latitude: customLatitude, longitude: customLongitude } = {}) => {
      if (appBannerFetchLockRef.current) {
        return [];
      }

      appBannerFetchLockRef.current = true;

      try {
        const payload = {
          latitude: String(customLatitude ?? latitude ?? "").trim(),

          longitude: String(customLongitude ?? longitude ?? "").trim(),
        };

        console.log("GET APP BANNER PAYLOAD:", payload);

        const res = await api.post("/Chaafo/getAppBanner", payload, {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json-patch+json",
          },
        });

        const data = res?.data;

        if (data?.responseCode === "00") {
          return Array.isArray(data?.response) ? data.response : [];
        }

        toast.error(data?.responseMessage || "Failed to fetch app banners");

        return [];
      } catch (error) {
        console.error("getAppBanner error:", error?.response || error);

        toast.error(
          error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Failed to fetch app banners",
        );

        return [];
      } finally {
        appBannerFetchLockRef.current = false;
      }
    },
    [api, latitude, longitude],
  );



const uploadAppBannerImage = async (file, type) => {
  if (!file) {
    toast.error("Please select an image");
    return null;
  }

  try {
    const formData = new FormData();

    formData.append("image", file);
    formData.append("type", type);

    const res = await api3.post(
      "/upload.php",
      formData
    );

    return res.data;

  } catch (error) {
    console.error(
      "Image upload error:",
      error?.response?.data || error.message
    );

    toast.error("Failed to upload image");

    return null;
  }
};
  return {
    fetchBanner,
    updateBannerStatus,
    fetchStatus,
    status,
    createBanner,
    deleteBanner,
    createAppBanner,
    fetchAppBanner,
    uploadAppBannerImage,
    deleteAppBanner
  };
};

export default useBanner;
